<template>
  <div class="app-container">
    <router-view />
  </div>
</template>

<script setup>
function detectBrowserLanguage() {
  // 如果已经设置过语言，则不再检测
  if (localStorage.getItem('language')) {
    return;
  }

  const browserLanguage = navigator.language || navigator.userLanguage;
  if (browserLanguage.startsWith('CN')) {
    localStorage.setItem('language', 'CN');
  } else {
    localStorage.setItem('language', 'EN');
  }
}
//检测浏览器语言
detectBrowserLanguage()
</script>

<style>
.el-dialog__header {
  font-size: 0.3rem !important;
}

html,
body,
#app {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  background-color: #000;
  /* overflow-x: hidden; */
}

.app-container {
  width: 100%;
  min-height: 100vh;
  position: relative;
  /* overflow-x: hidden; */
}
</style>
